export enum DateFormatType {
	MMDDYYYY = 'MM/DD/YYYY',
	DDMMYYYY = 'DD/MM/YYYY',
	YYYYMMDD = 'YYYY/MM/DD',
	DDMMYYYYHH = 'DD/MM/YYYY HH:mm'
}
